import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMyProfile: build.query<GetMyProfileApiResponse, GetMyProfileApiArg>({
      query: (queryArg) => ({
        url: `/v1/me/profile`,
        headers: { "Accept-Language": queryArg["Accept-Language"] },
      }),
    }),
    updateMyProfile: build.mutation<
      UpdateMyProfileApiResponse,
      UpdateMyProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/me/profile`,
        method: "PUT",
        body: queryArg.userProfileUpdateRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type GetMyProfileApiResponse =
  /** status 200 The users profile */ UserProfile;
export type GetMyProfileApiArg = {
  /** string */
  "Accept-Language"?: string;
};
export type UpdateMyProfileApiResponse =
  /** status 200 OK */ SuccessResponse200;
export type UpdateMyProfileApiArg = {
  /** New Profile info */
  userProfileUpdateRequest: UserProfileUpdateRequest;
};
export type FeatureKey = "chat" | "credit_purchase";
export type ImageResponse = {
  type?: string;
  url?: string;
};
export type ImageMediaResponse = {
  content?: ImageResponse[];
  id?: string;
};
export type Product = {
  description?: string;
  googleVendorProductId?: string;
  id?: string;
  priceLevel?: number;
  vendorProductId?: string;
};
export type SubscriptionPackage = {
  description?: string;
  duration?: number;
  id?: string;
  name?: string;
  product?: Product;
  status?: "sps-active" | "sps-inactive";
};
export type Subscription = {
  cancelledAt?: string;
  endsAt?: string;
  id?: string;
  startsAt?: string;
  status?: "ss-active" | "ss-canceled" | "ss-expired";
  subscriptionPackage?: SubscriptionPackage;
};
export type UserProfile = {
  blockedFeatures?: FeatureKey[];
  credits?: number;
  email?: string;
  id?: string;
  image?: ImageMediaResponse;
  name?: string;
  origin?: "uo-facebook" | "uo-google" | "uo-apple" | "uo-internal";
  sendNotifications?: boolean;
  subscription?: Subscription;
  timezone?: string;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ErrorResponse403 = {
  code?: number;
  data?: {
    [key: string]: string;
  }[];
  message?: string;
};
export type SuccessResponse200 = {
  status?: string;
};
export type UserProfileUpdateRequest = {
  name?: string;
  profileImageId?: string;
  sendNotifications?: boolean;
  timezone?: string;
};
export const { useGetMyProfileQuery, useUpdateMyProfileMutation } =
  injectedRtkApi;
